import { getPlanOfCareReviewOrdersOptions, type PlanOfCareReviewViewModel, type OrderViewModel } from '@generated';
import { useSuspenseQuery } from '@tanstack/react-query';
import { Order } from '~/features/orders/Order';
import { OrdersTable } from '~/features/orders/OrdersTable';
import { useGetFullOrderOptions } from '~/features/orders/queries';

export function OrdersTab({ review }: { review: PlanOfCareReviewViewModel }) {
	const { data } = useSuspenseQuery(getPlanOfCareReviewOrdersOptions(review.id));
	return <OrdersTable rows={data} renderRowDetail={order => <RenderOrderDetails order={order} />} />;
}

function RenderOrderDetails({ order }: { order: OrderViewModel }) {
	const { data } = useSuspenseQuery(useGetFullOrderOptions(order.id));
	return (
		<div className="bg-white">
			<Order fullOrder={data} />
		</div>
	);
}
